import {Component, OnInit} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {IdleTimeoutService} from './services/idle-timeout.service';
import {ConfigService} from './services/config.service';
import {AuthService} from './services/auth.service';
import {AnalyticsService} from './services/analytics/analytics.service';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  endpointBff: string = '';
  isProduction: boolean = false;
  isManualPrompts = false;

  constructor(
    private keycloakService: KeycloakService,
    private idleTimeoutService: IdleTimeoutService,
    private configService: ConfigService,
    private authService : AuthService,
    private analyticsService: AnalyticsService,
    private router: Router
  ) {
this.router.events.subscribe((e) => {
  if (e instanceof NavigationEnd) {
    this.isManualPrompts = e.urlAfterRedirects.includes('manual-prompt');
  }
});
  }

  async ngOnInit(): Promise<void> {
  this.endpointBff = this.configService.getConfig('endpointBff') || '';
  this.isProduction = this.configService.getConfig('production') || false;
  this.analyticsService.inicializarPageViews();

  const isLoggedIn = await this.keycloakService.isLoggedIn();

  if (isLoggedIn) {
    this.idleTimeoutService.start();

    const token = await this.keycloakService.getToken();
    const tokenParsed = this.keycloakService.getKeycloakInstance().tokenParsed;
    const firstName = tokenParsed?.given_name || tokenParsed?.name || '';


    // 🔽 Aqui você busca os dados reais do backend
    await this.authService.fetchUserDataFromBackend();


  } else {
    this.idleTimeoutService.stop();
  }
}
}
